import React, {useState} from 'react'
import {FacetFilter} from '@findhotel/sapi'

import {Checkbox} from '@vio/atlas/Checkbox'
import {Box} from '@vio/atlas/helpers/Box'
import {Accordion} from '@vio/atlas/src/components/designSystem/Accordion'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {getVisibleFacetFilters} from '../utils'

interface Props {
  variant?: 'one-column' | 'two-columns'
  isExpandable?: boolean
  brands: FacetFilter[]
  selectedBrandIds: string[]
  onChange: (filterName: string, filterValue: string | null | undefined) => void
  limit?: number
}
export const PropertyBrandFilter: React.FC<Props> = ({
  variant = 'one-column',
  isExpandable = true,
  brands,
  selectedBrandIds,
  limit = 3,
  onChange
}) => {
  const [isExpanded, setExpanded] = useState(false)

  const filteredBrandIds = getVisibleFacetFilters(
    brands,
    isExpandable,
    isExpanded,
    limit
  )

  return (
    <>
      <Box
        marginBottom="s400"
        display="grid"
        gap="s400"
        gridTemplateColumns={
          variant === 'one-column' ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'
        }
      >
        {filteredBrandIds.map(brand => (
          <Checkbox
            key={brand.id}
            name={brand.value}
            value={brand.id}
            checked={selectedBrandIds?.includes(brand.id)}
            onChange={() => onChange('brandIds', brand.id)}
            label={brand.value}
            labelSize="bodyS"
          />
        ))}
      </Box>
      {isExpandable && (
        <Accordion
          isBottomAligned
          size="sm"
          header={
            isExpanded ? (
              <FormattedMessageWrapper
                id="showLess"
                defaultMessage="Show less"
              />
            ) : (
              <FormattedMessageWrapper
                id="showMore"
                defaultMessage="Show more"
              />
            )
          }
          onToggle={() => setExpanded(state => !state)}
        >
          <React.Fragment />
        </Accordion>
      )}
    </>
  )
}
